/* tslint:disable */
/* eslint-disable */
/**
 * MG-DX Patient API
 * API for Patient
 *
 * The version of the OpenAPI document: 0.2.0
 * Contact: developers@mg-dx.co.jp
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { tzDate } from "@mgdx-libs/dayjs";
import { exists, mapValues } from "../runtime";

export const PatientOTCMedicineRegistrableTypename = "PatientOTCMedicineRegistrable" as const;

/**
 *
 * @export
 * @interface PatientOTCMedicineRegistrable
 */
export interface PatientOTCMedicineRegistrable {
  /**
   *
   * @type {string}
   * @memberof PatientOTCMedicineRegistrable
   */
  finishedOn?: string;
  /**
   *
   * @type {string}
   * @memberof PatientOTCMedicineRegistrable
   */
  janCode: string;
  /**
   *
   * @type {string}
   * @memberof PatientOTCMedicineRegistrable
   */
  name?: string;
  /**
   *
   * @type {string}
   * @memberof PatientOTCMedicineRegistrable
   */
  startedOn: string;
  /**
   * Resource type name
   * @type {string}
   * @memberof PatientOTCMedicineRegistrable
   */
  readonly __typename?: string;
}

export function PatientOTCMedicineRegistrableFromJSON(json: any): PatientOTCMedicineRegistrable {
  return PatientOTCMedicineRegistrableFromJSONTyped(json, false);
}

export function PatientOTCMedicineRegistrableFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): PatientOTCMedicineRegistrable {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    __typename: PatientOTCMedicineRegistrableTypename,

    finishedOn: !exists(json, "finished_on") ? undefined : json["finished_on"],
    janCode: json["jan_code"],
    name: !exists(json, "name") ? undefined : json["name"],
    startedOn: json["started_on"],
  };
}

export function PatientOTCMedicineRegistrableToJSON(object?: PatientOTCMedicineRegistrable | null): any {
  if (object === undefined) {
    return undefined;
  }
  if (object === null) {
    return null;
  }
  const { __typename, ...value } = object;
  return {
    finished_on: value.finishedOn,
    jan_code: value.janCode,
    name: value.name,
    started_on: value.startedOn,
  };
}
